import React from "react";
import {
  FormControl,
  FormControlLabel,
  Checkbox,
  FormGroup,
  InputLabel,
} from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function MuiCheckBoxGroup({
  items,
  valueKey = "value",
  labelKey = "label",
  onChange,
  // size = "medium",
  className,
  label,
  name,
  translate = false,
  selectAllShow = false,
  onSelectAll,
  ...props
}) {
  const { t } = useTranslation();
  return (
    <>
      <FormControl
        component="fieldset"
        className={`checkboxGroup ${className}`}
        {...props}
      >
        <InputLabel className="checkbox-label">
          {label}
          {selectAllShow && !items.every((item) => item.value) && (
            <div className="checkbox-select-all" onClick={(e) => onSelectAll(e, name)}>
              <Icons.Check />
              <Translator id="clickToSelectAll" />
            </div>
          )}
        </InputLabel>
        <FormGroup className="inner-checkbox-group">
          {Object.keys(items).map((index) => {
            if (Object.entries(items[index]).length !== 0) {
              return (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={items[index][valueKey]}
                      onChange={(e) => onChange(e, name, index, items[index])}
                    />
                  }
                  label={
                    translate ? (
                      <Translator id={items[index].key} />
                    ) : (
                      items[index][labelKey]
                    )
                  }
                />
              );
            } else {
              return null;
            }
          })}
        </FormGroup>
      </FormControl>
    </>
  );
}

export default MuiCheckBoxGroup;
